import React from 'react';
import { BottomNavigation, BottomNavigationAction, Hidden } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Procesos from '@material-ui/icons/ImportContacts';
import CreateIcon from '@material-ui/icons/Create';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import LoopIcon from '@material-ui/icons/Loop';
import SettingsIcon from '@material-ui/icons/Settings';
import { LibraryBooks } from '@material-ui/icons';
import FolderIcon from '@material-ui/icons/Folder';
import HistoryIcon from '@material-ui/icons/History';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { COD_ESTADO_ATENDIDO } from '../../helper';


const clase = (item, selec, tipo = '') => item === selec ? `item_selec${tipo}` : `item_modulo`;
const esSeleccionado = (item, selec) => item === selec;

export function MenuAdministrar({ administrador, sele = 0, seleccionar = () => { } }) {
  const pintar = (app, claseN = '') => {
    const opProcesos = 'proceso';
    const opAdministrar = 'administrar';
    if (!app) {
      return (
        <div className={claseN}>
          <BottomNavigation showLabels className={clase(opProcesos, sele)} onClick={() => seleccionar(opProcesos)}>
            <BottomNavigationAction label={"Procesos"} icon={<LocationOnIcon />} />
          </BottomNavigation>
          {
            administrador &&
            <BottomNavigation showLabels className={clase(opAdministrar, sele)} onClick={() => seleccionar(opAdministrar)}>
              <BottomNavigationAction label={"Administrar"} icon={<SettingsIcon className='menu_icono' />} />
            </BottomNavigation>
          }
        </div>
      )
    } else {
      return (
        <div className={claseN}>
          <BottomNavigation showLabels >
            <BottomNavigationAction label={'Procesos'} icon={<LocationOnIcon />} className={clase(opProcesos, sele, '_app')} onClick={() => seleccionar(opProcesos)} />
            {
              administrador &&
              <BottomNavigationAction label={'Administrar'} icon={<SettingsIcon />} className={clase(opAdministrar, sele, '_app')} onClick={() => seleccionar(opAdministrar)} />
            }
          </BottomNavigation>
        </div>
      )
    }
  }
  return (
    <div>
      <div>
        <Hidden xsDown> {pintar(false, 'menu_modulo')} </Hidden>
        <Hidden smUp> {pintar(true, 'menu_modulo_app')}</Hidden>
      </div>
    </div>
  );
}


export function MenuEstudiante({ sele = 0, seleccionar = () => { } }) {
  const pintar = (app, claseN = '') => {
    if (!app) {
      return (
        <div className={claseN}>
          <BottomNavigation showLabels className={clase('proceso', sele)} onClick={() => seleccionar('proceso')}>
            <BottomNavigationAction label={'Procesos'} icon={<LocationOnIcon />} />
          </BottomNavigation>
          <BottomNavigation showLabels className={clase('agregar', sele)} onClick={() => seleccionar('agregar')}>
            <BottomNavigationAction label={'Nuevo'} icon={<CreateIcon />} />
          </BottomNavigation>
          <BottomNavigation showLabels className={clase('historial', sele)} onClick={() => seleccionar('historial')}>
            <BottomNavigationAction label={'Historial'} icon={<Procesos />} />
          </BottomNavigation>
        </div>
      )
    } else {
      return (
        <div className={claseN}>
          <BottomNavigation showLabels >
            <BottomNavigationAction label={'Procesos'} icon={<LocationOnIcon />} className={clase('proceso', sele, '_app')} onClick={() => seleccionar('proceso')} />
            <BottomNavigationAction label={'Nuevo'} icon={<CreateIcon />} className={clase('agregar', sele, '_app')} onClick={() => seleccionar('agregar')} />
            <BottomNavigationAction label={'Historial'} icon={<Procesos />} className={clase('historial', sele, '_app')} onClick={() => seleccionar('historial')} />
          </BottomNavigation>
        </div>
      )
    }
  }

  return (
    <div>
      <div>
        <Hidden xsDown> {pintar(false, 'menu_modulo')} </Hidden>
        <Hidden smUp> {pintar(true, 'menu_modulo_app')}</Hidden>
      </div>
    </div>
  );
}

export function BienestarMenu({ sele = 0, seleccionar = () => { }, onlyDetalle = false, estadoActual = null, perfil = null, esEquidadGenero = false, seccionesVisibles = {} }) {
  const theme = useTheme();
  const esMovil = useMediaQuery(theme.breakpoints.down('sm'));

  const contenedorMenuStyle = {
    border: '1px solid #eeeeee',
    backgroundColor: 'white',
    width: '100%',
    overflowX: esMovil ? 'auto' : 'visible',
    WebkitOverflowScrolling: 'touch',
  };

  const navStyle = {
    width: esMovil ? 'max-content' : '100%',
    minWidth: '100%',
    justifyContent: esMovil ? 'flex-start' : 'space-evenly',
    backgroundColor: 'white',
  };

  const accionStyle = {
    flex: esMovil ? '0 0 auto' : '1 1 0',
    minWidth: esMovil ? 92 : 0,
    maxWidth: esMovil ? 200 : 'none',
    padding: esMovil ? '6px 4px' : '8px 6px',
    margin: '0 3px',
    border: '1px solid #eeeeee',
    backgroundColor: '#eeeeee',
  };

  const accionSeleccionadaStyle = {
    borderBottom: '4px solid var(--primary-color)',
    backgroundColor: 'var(--fondoiconoselect)',
  };

  const labelStyle = {
    whiteSpace: 'normal',
    lineHeight: 1.15,
    fontSize: 10,
    marginTop: 4,
    textAlign: 'center',
  };

  const pintar = (claseN = '') => {
    const verHistorialEstudiante = perfil && (perfil === 'Per_Adm' || perfil === 'Per_Bien_Gest' || perfil === 'Per_Bien_Ps');
    const estadoValido = estadoActual?.codigo == COD_ESTADO_ATENDIDO;
    const esValido = !esEquidadGenero && estadoValido && verHistorialEstudiante;
    const verFichas = seccionesVisibles.fichas !== false;
    const verExtras = seccionesVisibles.extras !== false;
    const verGenerados = seccionesVisibles.generados !== false;
    return (
      <div className={claseN} style={contenedorMenuStyle}>
        <BottomNavigation showLabels style={navStyle}>
          <BottomNavigationAction label={'Detalle'} icon={<ImportContactsIcon />} style={{ ...accionStyle, ...(esSeleccionado('detalle', sele) ? accionSeleccionadaStyle : {}) }} className={clase('detalle', sele)} onClick={() => seleccionar('detalle')} />
          {!onlyDetalle && <BottomNavigationAction label={'Estados'} icon={<LoopIcon />} style={{ ...accionStyle, ...(esSeleccionado('estados', sele) ? accionSeleccionadaStyle : {}) }} className={clase('estados', sele)} onClick={() => seleccionar('estados')} />}
          {!onlyDetalle && <BottomNavigationAction label={'Observaciones'} icon={<LibraryBooks />} style={{ ...accionStyle, ...(esSeleccionado('observaciones', sele) ? accionSeleccionadaStyle : {}) }} className={clase('observaciones', sele)} onClick={() => seleccionar('observaciones')} />}
          {!onlyDetalle && verExtras && <BottomNavigationAction label={'Documentos Extras'} icon={<FolderIcon />} style={{ ...accionStyle, ...(esSeleccionado('documentos_extras', sele) ? accionSeleccionadaStyle : {}) }} className={clase('documentos_extras', sele)} onClick={() => seleccionar('documentos_extras')} />}
          {!onlyDetalle && <BottomNavigationAction label={'Material de Apoyo'} icon={<FolderIcon/>} style={{ ...accionStyle, ...(esSeleccionado('adjuntos', sele) ? accionSeleccionadaStyle : {}) }} className={clase('adjuntos', sele)} onClick={() => seleccionar('adjuntos')} />}
          {!onlyDetalle && esValido && verFichas && <BottomNavigationAction label={'Ficha de Seguimiento'} icon={<AssignmentIcon />} style={{ ...accionStyle, ...(esSeleccionado('ficha_seguimiento', sele) ? accionSeleccionadaStyle : {}) }} className={clase('ficha_seguimiento', sele)} onClick={() => seleccionar('ficha_seguimiento')} />}
          {!onlyDetalle && verHistorialEstudiante && verGenerados && <BottomNavigationAction label={'Documentos Generados'} icon={<FolderIcon />} style={{ ...accionStyle, ...(esSeleccionado('documentos_generados', sele) ? accionSeleccionadaStyle : {}) }} className={clase('documentos_generados', sele)} onClick={() => seleccionar('documentos_generados')} />}
          {!onlyDetalle && verHistorialEstudiante && <BottomNavigationAction label={'Historial Estudiante'} icon={<HistoryIcon/>} style={{ ...accionStyle, ...(esSeleccionado('historial_estudiante', sele) ? accionSeleccionadaStyle : {}) }} className={clase('historial_estudiante', sele)} onClick={() => seleccionar('historial_estudiante')} />}
        </BottomNavigation>
        <style>{`.bienestar-menu-modal .MuiBottomNavigationAction-label{white-space:${labelStyle.whiteSpace};line-height:${labelStyle.lineHeight};font-size:${labelStyle.fontSize}px;margin-top:${labelStyle.marginTop}px;text-align:${labelStyle.textAlign};}`}</style>
      </div>
    )
  }
  return pintar('bienestar-menu-modal');
}
